<script>
    import { res } from './stores.js';
    import { loadBotCharts } from './loader.js';


function getIDfromURL(url){
    // https://docs.google.com/spreadsheets/d/1AcwKnCwbdwt4_ID3cb_ljlkPiqWpHxnvOLOVfESmswg/edit?gid=755165652#gid=755165652
    let match = url.match(/spreadsheets\/d\/([^\/]+)\//);
    if(match) return match[1];
}

export let ready;
export let captainsAvailable;

async function resetCharts(){
    let savedReady = ready;
    ready = false; 

    let id = prompt('Confirm sandbox URL:', `https://docs.google.com/spreadsheets/d/${$res.botSandboxID}/edit#`);
    if(id && id.startsWith('http')){
        id = getIDfromURL(id);
    }
    if(!id){
        alert(`Can't parse ID from URL: giving up`);
        ready = savedReady;
        return;
    }
    $res.botSandboxID = id;

    $res.botCharts = await loadBotCharts(true); 
    ready = true;
}

</script>

<div>
    <input type="checkbox" bind:checked={$res.useSandbox} on:change={resetCharts} /> Use bot sandbox instead of usual charts?
</div>
